import { Component, OnDestroy, OnInit } from '@angular/core';
import { Go } from '@app/core/store/actions/router.actions';
import { State } from '@app/store/reducers';
import { AuthSelectors } from '@core/auth/store';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-landing-redirector',
    templateUrl: './landing-redirector.component.html',
    styleUrls: ['./landing-redirector.component.scss'],
    standalone: true,
})
export class LandingRedirectorComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  constructor(private store: Store<State>) {}

  ngOnInit() {
    this.store
      .pipe(takeUntil(this.destroyed$), select(AuthSelectors.selectCurrentUserHasGlobalRole))
      .subscribe((currentUserHasGlobalRole) => {
        if (currentUserHasGlobalRole) {
          this.store.dispatch(Go({ path: [`/app/global-admin`] }));
        } else {
          this.store.dispatch(Go({ path: [`/app/trucks`] }));
        }
      });
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }
}
